// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw","container":"Section_container__vEvWA","title":"Section_title__SLHvV"};